import { useContext } from "react";
import { ToastsContext } from "./toastsContext";

export const useToastsContext = () => {
  const context = useContext(ToastsContext);
  if (!context) {
    throw new Error("useToastsContext must be used within a ToastsContextProvider");
  }
  return context;
};
